import Vue from 'vue';
export const EventBus = new Vue();


//////////////////
// WEBPACK FOOTER
// ./node_modules/modal-export/src/services/eventBus.js
// module id = X95T
// module chunks = 0